

















import { Component, Vue } from 'vue-property-decorator';
import TranslationApiAgent from '../../services/translation-api-agent';
import AuthApiAgent from '../../services/auth-api-agent';
import BbParserService from '../../services/bb-parser.service';
import SessionService from '../../services/session-service';
import CardMenu from '../../components/CardMenu.vue';
import { CardMenuItem } from '../../interfaces/card-menu.interface';

// @ts-ignore
@Component({
  components: {
    'card-menu': CardMenu
  }
})
export default class Admin extends Vue {
  private text: string = this.translationApiAgent.get('soon');
  private usernamePlaceholder: string = this.translationApiAgent.get('username');
  private passwordPlaceholder: string = this.translationApiAgent.get('password');
  private login: string = this.translationApiAgent.get('login');
  private username: string = '';
  private password: string = '';
  private error: string = '';
  private cardMenu: CardMenuItem[] = [];

  constructor(
    private translationApiAgent = TranslationApiAgent,
    private authApiAgent = AuthApiAgent,
    private sessionService = SessionService) {
    super();
  }

  mounted() {
    this.fillCardMenu();
  }

  private fillCardMenu() {
    this.cardMenu.push({
      route: '/admin/pages',
      title: this.translationApiAgent.get('admin::page')
    });
    this.cardMenu.push({
      route: '/admin/news',
      title: this.translationApiAgent.get('admin::news')
    });
    this.cardMenu.push({
      route: '/admin/programs',
      title: this.translationApiAgent.get('admin::programs')
    });
    this.cardMenu.push({
      route: '/admin/files',
      title: this.translationApiAgent.get('admin::files')
    });
    this.cardMenu.push({
      route: '/admin/galleries',
      title: this.translationApiAgent.get('admin::gallery')
    });
  }

  private tryLogin() {
    this.authApiAgent.auth(this.username, this.password).then(result => {
      if (result.session) {
        this.sessionService.set(result.session);
        window.location.reload();
      } else {
        this.error = result.result;
      }
    });
  }

  get isAdmin() {
    return this.authApiAgent.isAdmin;
  }

  get isIe() {
    return !!(window as any).MSInputMethodContext && !!(document as any).documentMode;
  }
}

